import { MINUTES_TO_MILLISECONDS } from './constants';

export const convertDateToGmtTimestamp = (date: Date): number => {
  if (!date) {
    return null;
  }

  return date.getTime() - date.getTimezoneOffset() * MINUTES_TO_MILLISECONDS;
};
